// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean, number, any } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdDevelopersDeveloperIdResult = objectOf({
  info: string,
  developers: arrayOf(
    objectOf({
      _id: string,
      email: string,
      first_name: string,
      last_name: string,
      full_name: string,
      department: string,
      image_url: string,
      authy_enabled: boolean,
      authy_id: any,
      two_factor_auth_enabled: boolean,
      selected_tfa_flow_type: any,
      braze_support_portal_access: boolean,
      subscribed_to_report: boolean,
      confirmed: boolean,
      last_signed_in_at: number,
      sign_in_count: any,
      internal_role: any,
      adhoc_permissions: arrayOf(
        objectOf({
          scope: number,
          scope_id: string,
          name: number,
          context: any,
        })
      ),
      permission_set_assignments: any,
      permissions: arrayOf(
        objectOf({
          scope: number,
          scope_id: string,
          name: number,
          context: any,
        })
      ),
      additional_internal_permissions: any,
      dismissed_banners: any,
      banner_exposures: any,
      company_id: string,
    })
  ),
});
